import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=0ccaab7c&scoped=true&"
import script from "./Education.vue?vue&type=script&lang=js&"
export * from "./Education.vue?vue&type=script&lang=js&"
import style0 from "./Education.vue?vue&type=style&index=0&id=0ccaab7c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccaab7c",
  null
  
)

export default component.exports